import { render, staticRenderFns } from "./Centered.vue?vue&type=template&id=652585b8"
import script from "./Centered.vue?vue&type=script&lang=js"
export * from "./Centered.vue?vue&type=script&lang=js"
import style0 from "./Centered.vue?vue&type=style&index=0&id=652585b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports